import _createForOfIteratorHelper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import "../../core/has.js";
import { isNone as e } from "../../core/maybe.js";

function r(e, r) {
  return e.vertexBuffers[r].size / t(e.layout[r]);
}

function t(e) {
  return e[0].stride;
}

function i(e, r, t, i, s) {
  var o = e.gl,
      n = e.capabilities.instancing;
  e.bindBuffer(t);

  var _iterator = _createForOfIteratorHelper(i),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var a = _step.value;

      var _e = r.get(a.name);

      void 0 === _e && console.error("There is no location for vertex attribute '".concat(a.name, "' defined.")), a.baseInstance && !a.divisor && console.error("Vertex attribute '".concat(a.name, "' uses baseInstanceOffset without divisor."));

      var _t = (s || (0 + a.baseInstance ? a.baseInstance : 0)) * a.stride;

      if (a.count <= 4) o.vertexAttribPointer(_e, a.count, a.type, a.normalized, a.stride, a.offset + _t), o.enableVertexAttribArray(_e), a.divisor > 0 && n && n.vertexAttribDivisor(_e, a.divisor);else if (9 === a.count) for (var _r = 0; _r < 3; _r++) {
        o.vertexAttribPointer(_e + _r, 3, a.type, a.normalized, a.stride, a.offset + 12 * _r + _t), o.enableVertexAttribArray(_e + _r), a.divisor > 0 && n && n.vertexAttribDivisor(_e + _r, a.divisor);
      } else if (16 === a.count) for (var _r2 = 0; _r2 < 4; _r2++) {
        o.vertexAttribPointer(_e + _r2, 4, a.type, a.normalized, a.stride, a.offset + 16 * _r2 + _t), o.enableVertexAttribArray(_e + _r2), a.divisor > 0 && n && n.vertexAttribDivisor(_e + _r2, a.divisor);
      } else console.error("Unsupported vertex attribute element count: " + a.count);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
}

function s(e, r, t, i) {
  var s = e.gl,
      o = e.capabilities.instancing;
  e.bindBuffer(t);

  var _iterator2 = _createForOfIteratorHelper(i),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var _n = _step2.value;

      var _e2 = r.get(_n.name);

      if (_n.count <= 4) s.disableVertexAttribArray(_e2), _n.divisor && _n.divisor > 0 && o && o.vertexAttribDivisor(_e2, 0);else if (9 === _n.count) for (var _r3 = 0; _r3 < 3; _r3++) {
        s.disableVertexAttribArray(_e2 + _r3), _n.divisor && _n.divisor > 0 && o && o.vertexAttribDivisor(_e2 + _r3, 0);
      } else if (16 === _n.count) for (var _r4 = 0; _r4 < 4; _r4++) {
        s.disableVertexAttribArray(_e2 + _r4), _n.divisor && _n.divisor > 0 && o && o.vertexAttribDivisor(_e2 + _r4, 0);
      } else console.error("Unsupported vertex attribute element count: " + _n.count);
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  e.unbindBuffer(34962);
}

function o(e) {
  switch (e) {
    case 6406:
    case 6409:
    case 36168:
    case 33778:
    case 33779:
    case 37490:
    case 37491:
    case 37496:
    case 37497:
      return 1;

    case 6410:
    case 32854:
    case 33325:
    case 32854:
    case 33189:
      return 2;

    case 6407:
    case 6402:
      return 3;

    case 6408:
    case 34041:
    case 33326:
    case 35898:
    case 33327:
    case 34041:
      return 4;

    case 33328:
    case 34842:
      return 8;

    case 34837:
      return 12;

    case 34836:
      return 16;

    case 33776:
    case 33777:
    case 37488:
    case 37489:
    case 37492:
    case 37493:
    case 37494:
    case 37495:
      return .5;
  }

  return 0;
}

function n(r) {
  if (e(r)) return 0;
  if ("descriptor" in r) return r.glName ? n(r.descriptor) : 0;
  var t = r.internalFormat || "pixelFormat" in r && r.pixelFormat;
  if (!t) return 0;
  var i = "hasMipmap" in r && r.hasMipmap ? 1.3 : 1,
      s = r.width * r.height;
  return o(t) * s * i;
}

export { i as bindVertexBufferLayout, o as getBytesPerElementFormat, n as getGpuMemoryUsage, t as getStride, s as unbindVertexBufferLayout, r as vertexCount };